// @flow

import Logging from '@ta/common.logging';

/**
 * The allowed event types when tracking an event.
 */
export type EventType = 'pageview' | 'impression' | 'action' | 'search';

/* eslint-disable-next-line no-restricted-globals */
const getSecurityToken = () => window.JS_SECURITY_TOKEN;

const getHeaders = () => ({
  'content-type': 'application/json',
  'x-requested-by': getSecurityToken(),
});

/**
 * Utility code to record unified user tracking events.
 * This will send the passed in data to the com.TripResearch.analytics.UserTrackingRecordServlet(.java)
 * which passes the data along to com.TripResearch.analytics.UserTracking.java
 * @param eventType - This matches up with the allowed values in com.TripResearch.analytics.UserTracking.UserTrackingEventType in java
 * @param eventName - any string identifying your event.
 * @param context - any additional data attributes in an object that maps to a Map<String, String> in java.
 */
const trackEventWithContext = (eventType: EventType, eventName: string, context: any): void => {
  const searchParams = new URLSearchParams();
  searchParams.append('event_name', eventName);
  searchParams.append('event_type', eventType);
  searchParams.append('attr', JSON.stringify(context));

  /**
   * For this initial version we will fire and forget...
   * we may want to add batching at a later date...
   */

  // fire and forget...
  fetch(`/UserTrackingRecord?${searchParams.toString()}`, {
    method: 'GET',
    headers: getHeaders(),
    credentials: 'same-origin',
  })
    .then(response => {
      if (!response.ok) {
        Logging.debug(
          `Did not get an ok status from the server for ${eventType}-${eventName}. Instead got: ${
            response.statusText
          }`,
        );
      }
      return response;
    })
    .catch(error => {
      Logging.error(
        `Error sending tracking event for ${eventType}-${eventName}. Err message is: ${
          error.message
        }`,
      );
    });
};

export default trackEventWithContext;
